export const supportedLocales = ['en', 'uk', 'ru'] as const;

export type Locale = (typeof supportedLocales)[number];

export const defaultLocale: Locale = 'en';

export const localeCookieName = 'NEXT_LOCALE';

export const localeHeaderName = 'x-platform-locale';

export const cityCookieName = 'NEXT_CITY';

export const cityHeaderName = 'x-platform-city';

export const countryCookieName = 'NEXT_COUNTRY';

export const countryHeaderName = 'x-platform-country';

export const localeToIntlCode: Record<Locale, string> = {
  en: 'en-US',
  uk: 'uk-UA',
  ru: 'ru-RU',
};

export function isSupportedLocale(value: string | null | undefined): value is Locale {
  if (!value) {
    return false;
  }

  return supportedLocales.includes(value as Locale);
}
